import { useState, useEffect } from 'react';
import CloseIcon from '../../../assets/icons/close.svg?react';
import Selector from '../../../components/Selector/Selector';

import { useUsers, useUserRoles } from '../../../hooks/queries/userRoleQueries';
import { useCreateNotificationTarget } from '../../../hooks/queries/logQueries';
const AlertTargetAppendSideModal = ({ onClose }) => {
  const createAlertTarget = useCreateNotificationTarget();
  const [isPending, setIsPending] = useState(false);
  const [formData, setFormData] = useState({
    targetType: null,
    targetValue: null,
  });

  const [selectedTargetType, setSelectedTargetType] = useState(null);
  const [selectedTargetValue, setSelectedTargetValue] = useState(null);
  
  const { data: users, isLoading: isLoadingUsers, refetch: refetchUsers } = useUsers();
  const { data: roles, isLoading: isLoadingRoles, refetch: refetchRoles } = useUserRoles();

  const targetTypeOptions = [
    { id: 'USER', label: '사용자', data: 'USER' },
    { id: 'ROLE', label: '역할', data: 'ROLE' },
  ];

  const transformUserData = (data) => {
    if (!data?.Items) return [];
    return data.Items.map((item) => ({
      id: item.UserSysId,
      label: item.Email,
      data: item,
    }));
  };
  const transformRoleData = (data) => {
    if (!data?.Items) return [];
    return data.Items.map((item) => ({
      id: item.RoleSysId,
      label: item.RoleName,
      data: item,
    }));
  };
  const buildApiParams = (searchQuery) => {
    return {
      email: searchQuery,
    };
  };
  const getQueryKeys = (searchQuery) => {
    return ['email', 'selector', searchQuery];
  };
  
  const buildRoleApiParams = (searchQuery) => {
    return {
      roleName: searchQuery,
    };
  };
  const getRoleQueryKeys = (searchQuery) => {
    return ['roleName', 'selector', searchQuery];
  };



  const handleAppendAlertTarget = async () => {
    try {
      setIsPending(true);
      await createAlertTarget.mutateAsync({
        targetType: formData.targetType,
        targetValue: formData.targetValue,
      });
      onClose();
    } catch (error) {
      console.error('알림 대상 추가 실패:', error);
      alert('알림 대상 추가에 실패했습니다.');
    } finally {
      setIsPending(false);
    }
  }


  useEffect(() => {
    if(selectedTargetType){
      setFormData({ ...formData, targetType: selectedTargetType.id, targetValue: null });
      setSelectedTargetValue(null);
    }
  }, [selectedTargetType]);
  
  useEffect(() => {
    if(selectedTargetValue){
      if(formData.targetType === 'USER'){
        setFormData({ ...formData, targetValue: selectedTargetValue?.data?.UserSysId });
      } else {
        setFormData({ ...formData, targetValue: selectedTargetValue?.data?.RoleName });
      }
    }
  }, [selectedTargetValue]);

  

  return (
    <div className="side-modal-background">
      <div className="side-modal-container">
        <div className="side-modal-header">
          <h3>알림 대상 추가</h3>
          <button className="side-modal-close" onClick={onClose}>
            <CloseIcon />
          </button>
        </div>
        <div className="side-modal-content">
          <table className='transparent-table w-full'>
            <tr>
              <td width="100px">
                <label htmlFor="targetType" className='w-20 mr-10 text-b2-700 required'>대상타입</label>
              </td>
              <td>
                <Selector id="targetType" options={targetTypeOptions} placeholder="대상타입을 선택해주세요." mode="local" value={selectedTargetType} onChange={setSelectedTargetType} enableSearch={false} />
              </td>
            </tr>
            <tr>
              <td>
                <label htmlFor="targetValue" className='w-20 mr-10 text-b2-700 required'>대상값</label>
              </td>
              <td>
                {selectedTargetType ? (
                  <>
                    {selectedTargetType.id === 'USER' ? (
                      <Selector
                      id="targetValue"
                      mode="api"
                      apiEndpoint="/drivecore/id/api/User" 
                      dataTransform={transformUserData} 
                      buildApiParams={buildApiParams} 
                      apiQueryKeys={getQueryKeys} 
                      value={selectedTargetValue} 
                      onChange={setSelectedTargetValue}
                      placeholder="사용자를 선택하세요"
                      enableSearch={true}
                      searchDebounceMs={500}/>
                    ) : (
                      <Selector
                      id="targetValue"
                      mode="api"
                      apiEndpoint="/drivecore/id/api/UserRole/getroles" 
                      dataTransform={transformRoleData} 
                      buildApiParams={buildRoleApiParams}
                      apiQueryKeys={getRoleQueryKeys}
                      value={selectedTargetValue} 
                      onChange={setSelectedTargetValue}
                      placeholder="역할을 선택하세요"
                      enableSearch={true}
                      searchDebounceMs={500}/>
                    )}
                  </>
                ): (
                  <div className="text-b2-400 text-gray-600">대상타입을 선택해주세요.</div>
                )}
              </td>
            </tr>
          </table>
          <div className="mt-10">
            <button className="btn btn-primary big-btn w-full" onClick={handleAppendAlertTarget} disabled={isPending || !formData.targetType || !formData.targetValue}>{isPending ? '추가중...' : '추가'}</button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AlertTargetAppendSideModal